interface DualProgressBarProps {
  usage: number // in bytes
  quota: number // in bytes
  usedColor: string // e.g., 'bg-btn-secondary' or 'bg-highlight'
}

export function DualProgressBar({ usage, quota, usedColor }: DualProgressBarProps) {
  const usageGB = usage / (1024 * 1024 * 1024)
  const quotaGB = quota / (1024 * 1024 * 1024)

  // Handle division by zero
  const usedPercentage = quotaGB === 0 ? 0 : Math.min(100, (usageGB / quotaGB) * 100)
  const remainingPercentage = Math.max(0, 100 - usedPercentage)

  return (
    <div className="flex gap-1 w-full h-8">
      {/* Used space segment */}
      {usedPercentage > 0 && (
        <div
          className={`${usedColor} rounded transition-all`}
          style={{ width: `${usedPercentage}%` }}
        />
      )}

      {/* Remaining space segment */}
      {remainingPercentage > 0 && (
        <div
          className="bg-neutral-50 rounded transition-all"
          style={{ width: `${remainingPercentage}%` }}
        />
      )}
    </div>
  )
}
